//selectedInvestmentForAppraisalslice

import { createSlice, PayloadAction } from "@reduxjs/toolkit";



interface InitialState {
    data: boolean ,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: false,
    error: '',
    loading: false
}

const appraisalSubmitEventSlice = createSlice({
    name: "appraisalSubmitEvent",
    initialState,
    reducers: {
        updateappraisalSubmitEvent(state, action: PayloadAction<boolean>) {
            state.data = action.payload;
        },
    },
});

export const { updateappraisalSubmitEvent } = appraisalSubmitEventSlice.actions;

export default appraisalSubmitEventSlice.reducer;